import { render, staticRenderFns } from "./PunishmentComponentView.vue?vue&type=template&id=5b98e664&"
import script from "./PunishmentComponentView.vue?vue&type=script&lang=js&"
export * from "./PunishmentComponentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports